// frontend/src/index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./setupConsoleFilters";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#000000",
      paper: "#121212", // 以前は #76B900（緑）→ 落ち着いたダークに変更
    },
    primary: {
      main: "#76B900", // ボタン等のアクセントとしてのみ使用
      contrastText: "#ffffff",
    },
    success: { main: "#2e7d32" },
    info: { main: "#64b5f6" },
    warning: { main: "#ffb74d" },
    text: { primary: "#FFFFFF" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: "#000000", margin: 0 },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);